<template>
  <div>
    <div class="search_area">
      <div class="search_bar">
        <span style="padding: 0 10px;">關鍵字搜尋</span>
        <input id="search_input" v-model="keyword" @keyup.enter="search"/>
        <span class="icon" @click="search">
          <svg style="height: 12px; width: 12px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
        </span>
      </div>
    </div>
    
    <div class="portlet_wrapper">
      <div class="cnt_block">
        <div class="table_holder">
          <table>
            <thead>
              <tr> <th>公司名稱</th> <th>詳細資料</th> </tr>
            </thead>
            <tbody>
              <tr v-for="tr in currentEnterprisesListGetter">
                <td>{{ tr.enterprise_name }}</td>
                <td> <router-link class="d-inline-block btn--pill pill blue" :to="`/teachers/enterprise/${tr.enterprise_id}`">詳細資料</router-link> </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'InternEnterprisesList',
  components: {
  },
  computed: {
    ...mapGetters('pages/teachers', [
      'currentEnterprisesListGetter',
    ]),
  },
  data () {
    return {
      keyword: '',
    };
  },
  async created () {
    this.togglePageLoader(true);
    await this.getEnterprisesList(this.keyword);
    this.togglePageLoader(false);
  },
  methods: {
    ...mapActions('pages/teachers', [
      'getEnterprisesList',
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    search () {
      this.getEnterprisesList(this.keyword);
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
